import Vue from 'vue'
import VueRouter from 'vue-router'
import Notice from '../views/Notice.vue'
import Learning from '../views/Learning.vue'
import Test from '../views/Test.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Notice',
    component: Notice
  },
  {
    path: '/learning',
    name: 'Learning',
    component: Learning
  },
  {
    path: '/test',
    name: 'Test',
    component: Test
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router 